<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Edit Category</h3>
        <form name="form1" @submit.prevent="save()">
          <p>
            <input v-model="cat.category" type="text" />
          </p>
          <p>
            <input type="submit" name="submit" value="Save" />
          </p>
        </form>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import CategoryRepository from "../../data/category.repository.js";
export default {
  data() {
    return {
      cat: {},
    };
  },
  created() {
    if (this.$route.params.id) {
      CategoryRepository.one(this.$route.params.id).then((category) => {
        this.cat = category;
      });
    }
  },
  methods: {
    save() {
      CategoryRepository.save(this.cat)
        .then((result) => {
          this.$root.$refs.toastr.s("Category saved");
          this.$router.push("/admin");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// EditCategory.vue?c0acbb5a